import { FC, SetStateAction, useState, useEffect } from 'react';
import { PATH_PLANRESULT, PATH_ORIGINSETTING, PATH_DRAFT_CONDITION_SETTING, PERMISSIONS, MESSAGES } from '../constants/const';
import Button from '../components/buttonBase';
import menuFill from '../image/menu_fill48.png';
import { useNavigate } from 'react-router-dom';
import { ENVIRONMENT } from '../constants/const';
import '../constants/const.css';
import './css/sidePanel.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import { LoginService } from '../logic/loginService';
import AppPane, { showConfirmMessage } from '../components/appPane';

interface SidePanelProps {
  isOpen: boolean;
  onClose: () => void;
  isUnsavedState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
}

const SidePanel: FC<SidePanelProps> = (props) => {
  const isVisible = false;

  const { permissions } = LoginService.getLoginInfo();

  const [enviromentName, setEnviromentName] = useState('');
  const [isUnsaved, setIsUnsaved] = props.isUnsavedState;

  useEffect(() => {
    const screenUrl: string = LoginService.getLoginInfo().screenUrl;
    setSelectedTab(screenUrl);
  }, []);

  useEffect(() => {
    const enviroment: string = ENVIRONMENT;

    const className = [enviroment === 'LOCAL' ? '-local' : enviroment === 'DEVELOP' ? '-develop' : enviroment === 'STAGING' ? '-staging' : enviroment === 'PRODUCTION' ? '' : '']
      .filter(Boolean)
      .join(' ');

    setEnviromentName(className);
  }, []);

  const navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState(2);
  const transition = async (path: string) => {
    let isTransition: boolean = true;
    if (isUnsaved) {
      isTransition = await showConfirmMessage(MESSAGES.CONFIRM_UNSAVED);
    }
    if (isTransition) {
      setIsUnsaved(false);
      navigate(path);
    } else {
      const screenUrl: string = LoginService.getLoginInfo().screenUrl;
      setSelectedTab(screenUrl);
    }
  };

  function setSelectedTab(screenUrl: string): void {
    if (screenUrl === PATH_PLANRESULT) {
      setSelectedValue(2);
    } else if (screenUrl === PATH_ORIGINSETTING) {
      setSelectedValue(3);
    } else if (screenUrl === PATH_DRAFT_CONDITION_SETTING) {
      setSelectedValue(4);
    }
  }

  const handleSelect = (value: SetStateAction<number>) => {
    setSelectedValue(value);
  };

  return (
    <>
      {props.isOpen ? (
        <div className={'open' + enviromentName + '-panel'}>
          <Button className="close-button" onClick={props.onClose}>
            <img className="closemenu-fill" src={menuFill} alt="button" id="passMask" width="22px" height="22px" style={{ marginTop: '-2px' }}></img>
          </Button>

          <ToggleButtonGroup className="navigate-button d-block" type="radio" name="nav" value={selectedValue}>
            {isVisible && (
              <ToggleButton className="navigate-button" variant="outline-light" size="lg" id="nav-1" value={0} style={{ border: 'transparent', borderRadius: '5px' }} disabled>
                {'TOP'}
              </ToggleButton>
            )}

            <hr className="menu-hr"></hr>
            {permissions &
            (PERMISSIONS.DRAFT_CONDITION_MAIN_EDIT |
              PERMISSIONS.DRAFT_CONDITION_MAIN_REFERENCE |
              PERMISSIONS.DRAFT_CONDITION_SUB_REFERENCE |
              PERMISSIONS.DRAFT_CONDITION_OTHER_REFERENCE) ? (
              <ToggleButton
                className="navigate-button"
                variant="outline-light"
                size="lg"
                id="nav-5"
                value={4}
                style={{ border: 'transparent', borderRadius: '5px' }}
                onClick={() => {
                  transition(PATH_DRAFT_CONDITION_SETTING);
                  setSelectedValue(4);
                }}
              >
                {'立案条件設定'}
              </ToggleButton>
            ) : (
              ''
            )}
            {permissions &
            (PERMISSIONS.PLAN_RESULT_MAIN_EDIT | PERMISSIONS.PLAN_RESULT_MAIN_REFERENCE | PERMISSIONS.PLAN_RESULT_SUB_REFERENCE | PERMISSIONS.PLAN_RESULT_OTHER_REFERENCE) ? (
              <ToggleButton
                className="navigate-button"
                variant="outline-light"
                size="lg"
                id="nav-3"
                value={2}
                style={{ border: 'transparent', borderRadius: '5px' }}
                onClick={() => {
                  transition(PATH_PLANRESULT);
                  setSelectedValue(2);
                }}
              >
                {'計画・実績表'}
              </ToggleButton>
            ) : (
              ''
            )}

            <hr className="menu-hr"></hr>
            {permissions & PERMISSIONS.ORIGIN_SETTING_MAIN_EDIT ? (
              <ToggleButton
                className="navigate-button"
                variant="outline-light"
                size="lg"
                id="nav-4"
                value={3}
                style={{ border: 'transparent', borderRadius: '5px' }}
                onClick={() => {
                  transition(PATH_ORIGINSETTING);
                  setSelectedValue(3);
                }}
              >
                {'初期設定'}
              </ToggleButton>
            ) : (
              ''
            )}
            {isVisible && permissions & (PERMISSIONS.BRANCH_MAIN_EDIT | PERMISSIONS.BRANCH_SUB_EDIT | PERMISSIONS.BRANCH_OTHER_EDIT) ? (
              <ToggleButton className="navigate-button" variant="outline-light" size="lg" id="nav-6" value={5} style={{ border: 'transparent', borderRadius: '5px' }} disabled>
                {'支所管理'}
              </ToggleButton>
            ) : (
              ''
            )}
            {isVisible && permissions & (PERMISSIONS.USER_MAIN_EDIT | PERMISSIONS.USER_SUB_EDIT | PERMISSIONS.USER_OTHER_EDIT) ? (
              <ToggleButton className="navigate-button" variant="outline-light" size="lg" id="nav-7" value={6} style={{ border: 'transparent', borderRadius: '5px' }} disabled>
                {'ユーザ管理'}
              </ToggleButton>
            ) : (
              ''
            )}
          </ToggleButtonGroup>
        </div>
      ) : (
        <div className={'close' + enviromentName + '-panel'}>
          <Button className="open-button" onClick={props.onClose}>
            <img className="openmenu-fill" src={menuFill} alt="button" id="passMask" width="20px" height="20px"></img>
          </Button>
        </div>
      )}
    </>
  );
};

export default SidePanel;
